export enum MADChartOptionsEnum {
    VOLUME,
    IMPRESSIONS,
    AVE,
    POSITIVE,
    NEGATIVE,
    DOMAIN_AUTHORITY
};
